import { checkErrorExist, convertError } from './converters';
import { handleFirstResponse } from '../utils/util_api_response';
import { getGlobalState, setGlobalState, STATE_KEYS } from '../configs/config_state';

import GLOBAL from '../configs/config_global';

// region GET - Tax List
export function getTaxList(userToken) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/account/taxes`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + userToken
            }
        })
            .then((response) => response.json())
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] GET TAX LIST', response);
                    resolve(response.data);
                }
                else {
                    console.log('[FAILED] GET TAX LIST', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] GET TAX LIST', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region POST - Create Tax
export function createTaxOption(name, value) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/account/taxes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ name, value })
        })
            .then((response) => response.json())
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] CREATE TAX OPTION', response);

                    // Add to global data
                    GLOBAL.DATA.SALES_TAX_OPTIONS[response.id] = response;

                    resolve(response);
                }
                else {
                    console.log('[FAILED] CREATE TAX OPTION', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] CREATE TAX OPTION', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region PATCH - Update Tax
export function updateTaxOption(taxID, name, value) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/account/taxes/${taxID}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ '_method': 'PATCH', name, value })
        })
            .then((response) => response.json())
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] UPDATE TAX OPTION', response);

                    // Update to global data
                    GLOBAL.DATA.SALES_TAX_OPTIONS[response.id] = response;

                    // Update in main app state
                    let tempArr = JSON.parse(JSON.stringify(getGlobalState(STATE_KEYS.LOCATION_LIST))),
                        locationIndex = tempArr.findIndex((item) => item['tax'] && item['tax'].id === response.id);

                    if (locationIndex > -1) {
                        tempArr[locationIndex].tax = response;
                        setGlobalState(STATE_KEYS.LOCATION_LIST, tempArr);
                    }

                    resolve(response);
                }
                else {
                    console.log('[FAILED] UPDATE TAX OPTION', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE TAX OPTION', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region DELETE - Tax
export function deleteTax(taxID) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/account/taxes/${taxID}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            }
        })
            .then((response) => handleFirstResponse(response))
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] DELETE TAX OPTION', response);

                    let deletedTax = null;

                    // Update to global data
                    if (GLOBAL.DATA.SALES_TAX_OPTIONS[taxID]) {
                        deletedTax = Object.assign({}, GLOBAL.DATA.SALES_TAX_OPTIONS[taxID]);
                        delete GLOBAL.DATA.SALES_TAX_OPTIONS[taxID];
                    }

                    // Update in main app state
                    let tempArr = JSON.parse(JSON.stringify(getGlobalState(STATE_KEYS.LOCATION_LIST))),
                        affectedLocations = [];

                    tempArr.forEach((item, index) => {
                        if (item['tax'] && item['tax'].id === taxID) {
                            affectedLocations.push(Object.assign({}, item, { index }));
                        }
                    });

                    if (affectedLocations.length > 0) {
                        affectedLocations.forEach((location) => tempArr[location.index].tax = null);
                        setGlobalState(STATE_KEYS.LOCATION_LIST, tempArr);
                    }

                    resolve({ deletedTax, affectedLocations });
                }
                else {
                    console.log('[FAILED] DELETE TAX OPTION', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] DELETE TAX OPTION', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region PATCH - Switch Tax
export function switchTax(isEnabled = false, locationTaxList = []) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/account/location-taxes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({
                '_method': 'PATCH',
                'tax_enabled': isEnabled ? 1 : 0,
                'locations': locationTaxList
            })
        })
            .then((response) => handleFirstResponse(response))
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] SWITCH TAX OPTION', response);

                    const newTruckData = Object.assign({}, getGlobalState(STATE_KEYS.TRUCK_DATA), { tax_enabled: isEnabled ? 1 : 0 });

                    // Update in main app state
                    setGlobalState(STATE_KEYS.TRUCK_DATA, newTruckData);
                    setGlobalState(STATE_KEYS.LOCATION_LIST, response?.locations || []);

                    // Update to global data
                    GLOBAL.DATA.USER = Object.assign(GLOBAL.DATA.USER, { trucks: [newTruckData] });

                    resolve(response);
                }
                else {
                    console.log('[FAILED] SWITCH TAX OPTION', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] SWITCH TAX OPTION', error.message);
                reject(error.message);
            });
    });
}
// endregion
